import ReactDOM from 'react-dom';
import { RouterProvider } from 'react-router-dom';

// third-party
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// scroll bar
import 'simplebar/src/simplebar.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';
import 'assets/third-party/full-calendar.css';

// project import
import { store, persister } from 'store';
import { ConfigProvider } from 'contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';
import DOMProtection from 'components/DOMProtection';

import 'flag-icons/css/flag-icons.min.css';
import { config } from './env';
import AppBaseRouter from 'AppBaseRouter';

// ==============================|| GLOBAL DOM ERROR HANDLER ||============================== //
// Suppress DOM manipulation errors from third-party scripts (Crisp, Google Translate, extensions)
// These errors occur when external scripts modify DOM that React is managing
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  const errorMessage = args[0]?.toString?.() || '';
  const suppressPatterns = [
    'removeChild',
    'insertBefore',
    'appendChild',
    'replaceChild',
    'not a child of this node',
    'not a sub-node of this node'
  ];
  
  const shouldSuppress = suppressPatterns.some((pattern) => 
    errorMessage.toLowerCase().includes(pattern.toLowerCase())
  );
  
  if (!shouldSuppress) {
    originalConsoleError.apply(console, args);
  }
};

// ==============================|| STORAGE VERSION CHECK ||============================== //
// Increment this version when you deploy changes that require clearing user storage
const STORAGE_VERSION = config.storageVersion;
const STORAGE_VERSION_KEY = 'APP_STORAGE_VERSION';

const storedVersion = localStorage.getItem(STORAGE_VERSION_KEY);
if (storedVersion !== STORAGE_VERSION) {
  // Clear all storage
  localStorage.clear();
  sessionStorage.clear();

  // Clear IndexedDB databases
  if (window.indexedDB && window.indexedDB.databases) {
    window.indexedDB.databases().then((databases) => {
      databases.forEach((db) => {
        if (db.name) window.indexedDB.deleteDatabase(db.name);
      });
    });
  }

  // Set the new version
  localStorage.setItem(STORAGE_VERSION_KEY, STORAGE_VERSION);

  // Reload to ensure clean state
  window.location.reload();
}

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

if (config.env_name === 'prod') {
  console.log = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

ReactDOM.render(
  <DOMProtection>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persister}>
        <ConfigProvider>
          <RouterProvider router={AppBaseRouter}></RouterProvider>
          {/* <BrowserRouter>
            <App />
          </BrowserRouter> */}
        </ConfigProvider>
      </PersistGate>
    </ReduxProvider>
  </DOMProtection>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
